// extracted by mini-css-extract-plugin
export default {"alfa":"GroupeEmail_alfa__Legxa","btadd":"GroupeEmail_btadd__CpSNc","creer":"GroupeEmail_creer__UGriC","comtnet":"GroupeEmail_comtnet__ACt3U","fontSize":"GroupeEmail_fontSize__GlxLw"};